<template>
  <div>
    <v-file-input
      v-model="file"
      :accept="accept.map(type => `.${type}`).join(', ')"
      base-color="primary"
      bg-color="white"
      color="primary"
      :density="dense ? 'compact' : 'default'"
      :disabled="disabled"
      :label="label"
      prepend-icon=""
      :prepend-inner-icon="Icon"
      :rules="Rules"
      :variant="outlined ? 'outlined' : 'underlined'"
    >
      <template v-slot:append-inner>
        <v-btn
          v-if="modelValue && modelValue.idBlob && !modelValue.isEdited"
          class="mr-1"
          color="primary"
          size="x-small"
          style="margin-top: 2px"
          @click.stop="Download()"
        >
          Download
        </v-btn>
        <v-btn
          color="primary"
          size="x-small"
          style="margin-top: 2px"
        >
          Bladeren
        </v-btn>
      </template>
    </v-file-input>
  </div>
</template>

<script>
export default {
  name: 'ControlInput',
  props: {
    accept: Array,
    acceptText: {
      default: 'Invalid file type.',
      type: String
    },
    dense: Boolean,
    disabled: Boolean,
    label: String,
    maxFileSize: Number,
    maxFileSizeText: {
      default: 'File size should be less than @@maxFileSizeMB.',
      type: String
    },
    multiple: Boolean,
    required: Boolean,
    requiredText: {
      default: 'Required.',
      type: String
    },
    outlined: Boolean,
    modelValue: Object
  },
  data () {
    return {
      ignore: true,
      file: null,
      formattedFile: null,
      rules: {
        accept: value => !value || !value[0] || !value[0].name || this.accept.includes(value[0].name.split('.').pop().toLowerCase()) || this.acceptText,
        maxFileSize: value => !value || !value[0] || !value[0].size || value[0].size < (this.maxFileSize * 1024 * 1024) || this.maxFileSizeText.replaceAll('@@maxFileSize', this.maxFileSize),
        required: value => !!value || this.requiredText
      }
    }
  },
  mounted () {
    this.FormatData()

    if (!this.modelValue?.bestandsnaam) {
      this.ignore = false
    }
  },
  computed: {
    Icon () {
      // return 'mdi-paperclip'
      return ''
    },
    Rules () {
      const rules = []

      if (this.accept && this.accept.length) {
        rules.push(this.rules.accept)
      }

      if (this.maxFileSize) {
        rules.push(this.rules.maxFileSize)
      }

      if (this.required) {
        rules.push(this.rules.required)
      }

      return rules
    }
  },
  watch: {
    file () {
      if (!this.ignore) {
        this.Emit()
      } else {
        this.ignore = false
      }
    },
    modelValue () {
      this.FormatData()
      this.ignore = false
    }
  },
  methods: {
    Download () {
      this.$emit('download')
    },
    Emit () {
      if (this.file) {
        if (this.file.size) {
          this.$emit('name', this.file.name)

          const reader = new FileReader()

          reader.onload = (e) => {
            this.$emit('data', e.target.result)
          }

          reader.readAsDataURL(this.file)
        }
      } else {
        this.$emit('clear')
        this.$emit('name', null)
        this.$emit('data', null)
      }

      this.$emit('change')
    },
    FormatData () {
      if (this.modelValue && this.modelValue.bestandsnaam && this.modelValue.bestandsnaam.trim() !== '') {
        this.file = {
          name: this.modelValue.bestandsnaam
        }
      } else {
        this.file = null
      }
    }
  }
}
</script>
